<script>
import EyeOn from '@/assets/starface_icons_png/24/orange/eye-on_24.png';
import EyeOff from '@/assets/starface_icons_png/24/orange/eye-off_24.png';

export default {
    name: 'PasswordInput',
    props: {
        value: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: true
        },
        hasError: {
            type: Boolean,
            required: true
        },
        v: {
           type: Object,
            required: false,
        },
    },
    data() {
        return {
            isVisible: false,
            inputVal: this.value,
            imageSource: EyeOn,
        };
    },
    watch: {
        inputVal(value) {
            this.$emit('input', value);
            if (this.v) {
                this.v.$touch();
            }
        }
    },
    computed: {
        inputType() {
            return this.isVisible ? 'text' : 'password';
        }
    },
    methods: {
        clickOnEye() {
            this.isVisible = !this.isVisible;
            this.isVisible ? this.imageSource = EyeOff : this.imageSource = EyeOn;
        },
    },
};
</script>

<template>
    <div class="form-group">
            <label for="password">{{label}}</label>
            <input ref="input" :type="inputType" name="password" id="password" class="form-control"
                   v-bind:class="{ 'has-error': hasError }" v-model="inputVal" required autocomplete="false"/>
            <span class="input-icon" @click="clickOnEye">
                <img :src="imageSource"/>
            </span>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
@import '../../assets/scss/inputs.scss';

.form-group {
    position: relative;
    margin-bottom: 31px;
    text-align: left;
    label {
        display: inline-block;
        color: #b8b8b8;
        font-size: 14px;
        margin-bottom: 10px;
    }
    .form-control {
        display: block;
        width: 100%;
        height: 24px;
        font-size: 18px;
        line-height: 24px;
        color: $grey-dark;
        background-color: transparent;
        background-clip: padding-box;
        border: none;
        border-bottom: 2px solid #e8e8e8;
        text-align: left;
        border-radius: 0;
        padding: 0;
        &:focus {
            outline: none;
        }
        &.has-error {
            border-color: #f54d00;
        }
    }

    .input-icon {
        position: absolute;
        right : 10px;
        top: 30px;
        cursor: pointer;

    }
}
</style>
